<template>
    <div class="settings includes-header">

        <header class="page-header settings-header">
            <router-link :to="{ name: 'root' }" class="back tag button-timid left" v-if="!inModal">x Sluiten</router-link>
            <h1>Instellingen</h1>
            <p>Hier kun je jouw gegevens aanpassen.</p>
        </header>

        <div class="settings-links tag">
            <a href="#" :class="{ 'is-active': personalActive }" @click.prevent="viewPersonal">Naam</a> |
            <a href="#" :class="{ 'is-active': emailActive }" @click.prevent="viewEmail">E-mail</a> |
            <a href="#" :class="{ 'is-active': passwordActive }" @click.prevent="viewPassword">Wachtwoord</a>
            <template v-if="isGroupAvailable">| <a href="#" :class="{ 'is-active': groupActive }" @click.prevent="viewGroup">Klas</a></template>
        </div>

        <router-view class="page-content" :user="user" v-if="!inModal"></router-view>
        <component :is="view" :user="user" v-else class="settings-modal-content" @done="done"></component>

    </div>
</template>


<script>
import User from 'js/components/settings/User.vue'
import Email from 'js/components/settings/Email.vue'
import Password from 'js/components/settings/Password.vue'
import Group from 'js/components/settings/Group.vue'

import track from 'js/helpers/analytics'
import { isStudent } from 'js/api/auth'

export default {
    name: 'Settings',
    props: [ 'inModal' ],
    components: { User, Password, Group, Email },

    data: function() {
        return {
            view: 'User',
        }
    },

    vuex: {
        getters: {
            user: state => state.users.current,
        }
    },

    computed: {
        personalActive: function() {
            return this.view === 'User' || this.$route.name === 'settings.user'
        },
        emailActive: function() {
            return this.view === 'Email' || this.$route.name === 'settings.email'
        },
        passwordActive: function() {
            return this.view === 'Password' || this.$route.name === 'settings.password'
        },
        groupActive: function() {
            return this.view === 'Group' || this.$route.name === 'settings.group'
        },

        isGroupAvailable: function() {
            return isStudent(this.user)
        }
    },

    methods: {
        viewPersonal: function() {
            if ( this.inModal ) {
                this.view = 'User'
            } else {
                this.$router.push({ name: 'settings.user' })
            }
        },
        viewEmail: function() {
            if ( this.inModal ) {
                this.view = 'Email'
            } else {
                this.$router.push({ name: 'settings.email' })
            }
        },
        viewPassword: function() {
            if ( this.inModal ) {
                this.view = 'Password'
            } else {
                this.$router.push({ name: 'settings.password' })
            }
        },
        viewGroup: function() {
            if ( this.inModal ) {
                this.view = 'Group'
            } else {
                this.$router.push({ name: 'settings.group' })
            }
        },

        done: function() {
            this.$emit('close')
        },

    },

    created: function() {
        track.event('user', 'settings', this.user.id)
    }
}
</script>


<style lang="scss">

    @import 'global';
    @import 'settings';

</style>



// WEBPACK FOOTER //
// Settings.vue?2353fe31